import React, { FC } from "react";
import { CardProps } from "@material-ui/core/Card";
import { StyledMuiCard } from './styles';

const Card: FC<CardProps> = (props) => {
  return (
    <StyledMuiCard {...props} />
  );
};

export default Card;
